import { NodeResponse } from '@cast/types';

import { DEDICATED_NODE_LABEL } from '../constants/node-labels';

export const isSoleTenantNode = (node: Pick<NodeResponse, 'labels'>): boolean =>
  node.labels?.[DEDICATED_NODE_LABEL] === 'true';
